module.exports = __webpack_public_path__ + "static/media/teamslook.7fe41566.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/teamslook.png
// module id = 844
// module chunks = 7